module.exports = __webpack_public_path__ + "img/pil_no.e5038d7f.png";